<template>
  <div class="modal-parametros">
    <div class="header">
      <div class="close">
        <v-icon @click="returnScreen()" color="white">mdi-close</v-icon>
      </div>
      <h2>Parâmetros e Backup</h2>
    </div>
    <div class="body">
      <v-card class="mx-auto mt-3 pa-4" outlined>
        <v-icon class="mr-1" color="#777">mdi-camera</v-icon> CAMÊRA DO APARELHO
        <v-divider class="my-3"></v-divider>
        <v-select
          v-model="media_camera_type"
          :items="media_camera_options"
          hide-details
          outlined
          @change="(value) => updateParameter('media_camera_type', value)"
        ></v-select>
        <v-divider class="my-3"></v-divider>
        <small><b>Observação:</b> Utilize a câmera alternativa caso o aparelho reinicie ao utilizar a câmera original.</small>
      </v-card>
      <v-card class="mx-auto mt-3 pa-4" outlined>
        <v-icon class="mr-1" color="#777">mdi-camera-control</v-icon> MODO DE CAPTURA
        <v-divider class="my-3"></v-divider>
        <v-select
          v-model="media_capture_mode"
          :items="media_capture_mode_options"
          hide-details
          outlined
          @change="(value) => updateParameter('media_capture_mode', value)"
        ></v-select>
        <v-divider class="my-3"></v-divider>
        <small><b>Observação:</b> Modo dinâmico utiliza todos recursos da câmera, modo estável é mais rápido. Reinicie o app para aplicar as alterações.</small>
      </v-card>
      <v-card class="mx-auto mt-3 pa-4" outlined>
        <v-icon class="mr-1" color="#777">mdi-cloud-download</v-icon> BACKUP DE SEGURANÇA
        <v-divider class="my-3"></v-divider>
        <v-select
          v-model="media_backup.hours_stored_selected"
          :items="media_backup.hours_stored_options"
          hide-details
          outlined
          @change="(value) => updateParameter('media_backup_hours_stored', value)"
        ></v-select>
        <v-divider class="my-3"></v-divider>
        <small><b>Observação:</b> As fotos terão uma cópia de segurança armazenada no dispositivo pelo período selecionado.</small>
      </v-card>
      <v-card class="mx-auto mt-3 pa-4" outlined>
        <v-icon class="mr-1" color="#777">mdi-upload</v-icon> STATUS DE UPLOADS
        <v-divider class="my-3"></v-divider>
        <v-select
          v-model="show_upload_queue_status"
          :items="show_upload_queue_status_options"
          hide-details
          outlined
          @change="(value) => updateParameter('show_upload_queue_status', value)"
        ></v-select>
        <v-divider class="my-3"></v-divider>
        <small><b>Observação:</b> Quando ativado, exibe informações detalhadas sobre uploads em andamento e tentativas de reenvio.</small>
      </v-card>
    </div>
  </div>
</template>

<script>
import dexieDB from '@/services/dexieService';

export default {
  name: 'Parameters',
  data: () => ({
    loading: false,
    media_camera_type: 'original',
    media_camera_options: [
      { value: 'original', text: 'Câmera Principal' },
      { value: 'alternative', text: 'Câmera Alternativa' }
    ],
    media_capture_mode: 'dynamic',
    media_capture_mode_options: [
    { value: 'dynamic', text: 'Dinâmico' },
    { value: 'stable', text: 'Estável' }
    ],
    media_backup: {
      hours_stored_selected: 0,
      hours_stored_options: [
        { value: 0, text: 'Desativado' },
        { value: 24, text: '24 Horas' },
        { value: 48, text: '2 Dias' },
        { value: 72, text: '3 Dias' }
      ]
    },
    show_upload_queue_status: false,
    show_upload_queue_status_options: [
      { value: false, text: 'Desativado' },
      { value: true, text: 'Ativado' }
    ]
  }),
  async mounted() {
    const parameters = await dexieDB.getParameters();

    this.media_backup.hours_stored_selected = parameters.find(({ name }) => name === 'media_backup_hours_stored')?.value ?? 0;
    this.media_camera_type = parameters.find(({ name }) => name === 'media_camera_type')?.value ?? 'original';
    this.media_capture_mode = parameters.find(({ name }) => name === 'media_capture_mode')?.value ?? 'dynamic';
    this.show_upload_queue_status = parameters.find(({ name }) => name === 'show_upload_queue_status')?.value ?? false;
  },
  methods: {
    returnScreen() {
      this.$emit('return');
    },
    async updateParameter(parameter, value) {
      await dexieDB.upsertParameter(parameter, value);

      this.$store.dispatch('Auth/getParametersFromLocal');
    }
  }
};
</script>
